export default __webpack_public_path__ + "static/Guild-ad-bb87bee2c0b12d8e3d813baa42933f1b.jpg";